module.exports = __webpack_public_path__ + "img/clogo.e1d49c26.png";